import { faker } from '@faker-js/faker';
import { Conversation } from '@quadminds/client-apis/agents';

const now = new Date().toISOString();
const userId = faker.datatype.uuid();

export const generateConversationFaker = (): Conversation => {
    const conversationId = faker.datatype.uuid();
    const conversationFaker = {
        _id: conversationId,
        user_id: userId,
        title: `Prueba de Interacción con el Agente\n`,
        status: 'active',
        interactions: [
            {
                _id: faker.datatype.uuid(),
                conversation_id: conversationId,
                organization_id: '',
                user_id: userId,
                agent_id: 'logistics_agent',
                user_message: faker.lorem.sentence(),
                agent_response: faker.lorem.sentence(),
                context: [],
                tools_used: [],
                metadata: {
                    type: 'logistics',
                    timestamp: now,
                },
                usage_metadata: {
                    input_tokens: faker.datatype.number({ min: 1000, max: 6000 }),
                    output_tokens: faker.datatype.number({ min: 10, max: 100 }),
                    total_tokens: 0, // lo calculamos abajo
                    total_cost: faker.finance.amount(0.001, 0.01, 7),
                    model: 'gemini-2.0-flash-exp',
                    timestamp: now,
                },
                rating: '1',
                feedback_comment: '',
                rated_at: '',
                attachment: [
                    {
                        type: 'chart',
                        chartType: 'LineChart',
                        data: [
                            {
                                name: 'Page A',
                                uv: faker.datatype.number({ min: 0, max: 100 }),
                                pv: faker.datatype.number({ min: 0, max: 100 }),
                                amt: faker.datatype.number({ min: 0, max: 100 }),
                            },
                            {
                                name: 'Page B',
                                uv: faker.datatype.number({ min: 0, max: 100 }),
                                pv: faker.datatype.number({ min: 0, max: 100 }),
                                amt: faker.datatype.number({ min: 0, max: 100 }),
                            },
                            {
                                name: 'Page C',
                                uv: faker.datatype.number({ min: 0, max: 100 }),
                                pv: faker.datatype.number({ min: 0, max: 100 }),
                                amt: faker.datatype.number({ min: 0, max: 100 }),
                            },
                            {
                                name: 'Page D',
                                uv: faker.datatype.number({ min: 0, max: 100 }),
                                pv: faker.datatype.number({ min: 0, max: 100 }),
                                amt: faker.datatype.number({ min: 0, max: 100 }),
                            },
                            {
                                name: 'Page E',
                                uv: faker.datatype.number({ min: 0, max: 100 }),
                                pv: faker.datatype.number({ min: 0, max: 100 }),
                                amt: faker.datatype.number({ min: 0, max: 100 }),
                            },
                            {
                                name: 'Page F',
                                uv: faker.datatype.number({ min: 0, max: 100 }),
                                pv: faker.datatype.number({ min: 0, max: 100 }),
                                amt: faker.datatype.number({ min: 0, max: 100 }),
                            },
                            {
                                name: 'Page G',
                                uv: faker.datatype.number({ min: 0, max: 100 }),
                                pv: faker.datatype.number({ min: 0, max: 100 }),
                                amt: faker.datatype.number({ min: 0, max: 100 }),
                            },
                        ],
                        options: {
                            xKey: {
                                show: true,
                                key: 'name',
                            },
                            yKey: {
                                show: true,
                            },
                            showLegend: true,
                        },
                    },
                ],
            },
        ],
        metadata: {},
        usage_metadata: {},
        created_at: now,
        updated_at: new Date(Date.now() + 2000).toISOString(),
    };

    // Calcular total_tokens si querés coherencia
    conversationFaker.interactions[0].usage_metadata.total_tokens =
        conversationFaker.interactions[0].usage_metadata.input_tokens +
        conversationFaker.interactions[0].usage_metadata.output_tokens;
    return conversationFaker;
};

export const generatePatchConversationFaker = () => {
    return {
        _id: faker.datatype.uuid(),
        title: faker.lorem.sentence(),
        status: 'active', // Podés randomizarlo si querés otros estados también
        updated_at: faker.date.recent().toISOString(),
    };
};
